import { render, staticRenderFns } from "./PricingSection.vue?vue&type=template&id=94c71be0&scoped=true&"
import script from "./PricingSection.vue?vue&type=script&lang=js&"
export * from "./PricingSection.vue?vue&type=script&lang=js&"
import style0 from "./PricingSection.vue?vue&type=style&index=0&id=94c71be0&prod&lang=scss&"
import style1 from "./PricingSection.vue?vue&type=style&index=1&id=94c71be0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94c71be0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VContainer,VDivider,VProgressCircular,VRow})
